import useFirebaseData from "./useFirebaseData";
import type { Firing } from "../types";

const useFirebaseTemplateFiring = (firing_id: string, glass_type: string) => {
  return useFirebaseData<Firing>(
    glass_type && firing_id ? `/templates/firings/${glass_type}/${firing_id}` : null
  );
};

export default useFirebaseTemplateFiring;
